module.exports = __webpack_public_path__ + "media/images/user/circle-d5d745407944791816b5f454a276ee0a.svg";